/* eslint-disable @typescript-eslint/no-unused-vars */
import {ReactElement, useEffect, useState} from 'react';
import {
  MenuItem,
  OutlinedInput,
  InputLabel,
  CircularProgress,
  Typography,
  FormHelperText,
  Select,
  Box,
  Chip,
  SelectChangeEvent,
  Checkbox
  // useTheme
} from '@mui/material';
import {
  SelectField,
  TextLabelWrapperComponentDiv,
  FormHelperTextP
} from './SelectInputMultiStyle';
import {useTheme, Theme} from '@mui/material/styles';

export interface SelectInputProps {
  field?: any;
  sx?: any;
  options: Array<any>;
  name: string;
  multiple?: boolean;
  optionValueKey?: string;
  optionLabelKey?: string;
  enableDefaultOption?: boolean;
  errorMessage?: string;
  TextErrorMessage?: string;
  setValue?: string;
  onChange?: (e: any) => void;
  onChangeCallback?: any;
  label?: string;
  placeholder?: string;
  error?: any;
  value?: any;
  fullWidth?: any;
  disabled?: boolean;
  selectProps?: any;
  onOpenCallback?: any;
  fetchOptionsFromOnOpenTrigger?: boolean;
  MenuProps?: any;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

function getStyles(name: string, personName: readonly string[], theme: Theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular
  };
}

const SelectInputMulti = (props: SelectInputProps): ReactElement => {
  const theme = useTheme();
  const [currentValue, setCurrentValue] = useState<string[]>([]);
  const [optionsList, setOptionsList] = useState<any>([]);

  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const {
    options = [],
    optionValueKey = 'value',
    optionLabelKey = 'label',
    enableDefaultOption,
    placeholder,
    error,
    errorMessage,
    TextErrorMessage,
    value = '',
    label,
    fullWidth,
    disabled = false,
    onOpenCallback,
    onChangeCallback,
    fetchOptionsFromOnOpenTrigger,
    sx,
    ...rest
  } = props;
  const [optionss, setOPtions] = useState<any[]>([]);
  const generateSelectOptions = (data?: any) => {
    const data_list = data ?? options;
    // setOPtions(data_list);
    // const temp_list = data_list.map((option: any) => {
    //   return (
    //     <MenuItem key={option[optionValueKey]} value={option[optionValueKey]}>
    //       {option[optionLabelKey]}
    //     </MenuItem>
    //   );
    // });
    // const temp_list = data_list.map(item => item.value);
    // console.log(temp_list);
    // setOptionsList(temp_list);
    setOptionsList(data_list);
  };

  useEffect(() => {
    if (value.includes('select_all')) {
      const temp_list = optionsList.map((item: any) => item.value);
      setCurrentValue(temp_list);
    } else if (value.includes('clear_all')) {
      setCurrentValue([]);
    } else if (Array.isArray(value)) {
      setCurrentValue(value);
    } else if (value === '' || !value) {
      setCurrentValue([]);
    } else {
      setCurrentValue([value]);
    }
  }, [value]);

  const handleChange = (event: any) => {
    const {
      target: {value}
    } = event;
    if (value.includes('select_all')) {
      const temp_list = optionsList.map((item: any) => item.value);
      setCurrentValue(temp_list);
    } else if (value.includes('clear_all')) {
      setCurrentValue([]);
    } else {
      setCurrentValue(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value.split(',') : value
      );
    }
    if (onChangeCallback) {
      onChangeCallback(event);
    }
  };

  const handleOnOpen = async (e: any) => {
    setMenuAnchor(e.currentTarget);
    if (fetchOptionsFromOnOpenTrigger && options.length === 0) {
      setOptionsList(
        <MenuItem key={1} value={'loading'}>
          <span style={{marginRight: '5px'}}>{'...Loading'}</span>
          <CircularProgress size={24} />
        </MenuItem>
      );
      const temp_list = await onOpenCallback();
      generateSelectOptions(temp_list);
    }
  };

  useEffect(() => {
    if (!fetchOptionsFromOnOpenTrigger || options.length > 0) {
      generateSelectOptions();
    }
    // if (value.length) {
    //   console.log(value);
    //   setCurrentValue(value);
    // }
  }, [options]);

  return (
    <TextLabelWrapperComponentDiv>
      {label ? <InputLabel>{label}</InputLabel> : ''}
      <SelectField
        {...props?.selectProps}
        anchorEl={menuAnchor}
        disabled={disabled}
        variant="outlined"
        multiple
        value={currentValue}
        error={error}
        fullWidth={fullWidth}
        onChange={handleChange}
        input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
        sx={{
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#0000003b',
            borderWidth: '1.8px'
          },
          //   '& .MuiSelect-multiple': {
          //     padding: currentValue?.length ? '9.5px' : 'auto',
          //     paddingRight: currentValue?.length ? '15px' : 'auto'
          //   },
          ...sx
        }}
        {...rest}
        renderValue={(selected: any) => (
          <Typography
            noWrap
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: '150px', // Adjust based on your layout
              display: 'block'
            }}
            title={selected.join(', ')} // Shows full text on hover
          >
            {selected.join(', ')}
          </Typography>
        )}
        MenuProps={MenuProps}>
        <MenuItem
          value={
            currentValue?.length == optionsList.length
              ? 'clear_all'
              : 'select_all'
          }>
          <Checkbox
            checked={currentValue.length == optionsList.length}
            indeterminate={
              currentValue.length > 0 &&
              currentValue.length < currentValue.length
            }
          />
          <Typography>
            {currentValue?.length == optionsList.length
              ? 'Clear All'
              : 'Select All'}
          </Typography>
        </MenuItem>
        {optionsList.map((item: any) => (
          <MenuItem key={item.value} value={item.label}>
            <Checkbox checked={currentValue.includes(item.value)} />
            <Typography>{item.label}</Typography>
          </MenuItem>
        ))}
      </SelectField>

      {error && <FormHelperTextP>{errorMessage}</FormHelperTextP>}
      {error && <FormHelperText error>{TextErrorMessage}</FormHelperText>}
    </TextLabelWrapperComponentDiv>
  );
};

export default SelectInputMulti;
